export type HcpAttributeNames = {
    hcpId: 'buddyId' | 'hcpId';
    hcpName: 'buddyName' | 'hcpName';
    hcpGrade: 'buddyGrade' | 'hcpGrade';
    madeCurrentDateTime: 'buddyMadeCurrentDateTime' | 'madeCurrentDateTime';
    arrivedDateTime: 'buddyArrivedDateTime' | 'arrivedDateTime';
    finishedDateTime: 'buddyFinishedDateTime' | 'finishedDateTime';
    hcpAbortedDateTime: 'buddyHcpAbortedDateTime' | 'hcpAbortedDateTime';
    abortedBy: 'buddyAbortedBy' | 'abortedBy';
    jobStatus: 'buddyJobStatus' | 'jobStatus';
    jobStatusBeforeAbort: 'buddyJobStatusBeforeAbort' | 'jobStatusBeforeAbort';
    controllerAbortedReason: 'buddyControllerAbortedReason' | 'controllerAbortedReason';
    controllerAbortedNotes: 'buddyControllerAbortedNotes' | 'controllerAbortedNotes';
    controllerReverseReason: 'buddyControllerReverseReason' | 'controllerReverseReason';
    controllerReverseNotes: 'buddyControllerReverseNotes' | 'controllerReverseNotes';
    hcpAbortedReason: 'buddyHcpAbortedReason' | 'hcpAbortedReason';
    hcpAbortedNotes: 'buddyHcpAbortedNotes' | 'hcpAbortedNotes';
    hcpReverseReason: 'buddyHcpReverseReason' | 'hcpReverseReason';
    hcpReverseNotes: 'buddyHcpReverseNotes' | 'hcpReverseNotes';
    postVisitNotes: 'postVisitNotesBuddy' | 'postVisitNotes';
    withdrawnReason: 'withdrawnReason';
    withdrawnNotes: 'withdrawnNotes';
};

const hcp1Attributes: HcpAttributeNames = {
    hcpId: 'hcpId',
    hcpName: 'hcpName',
    hcpGrade: 'hcpGrade',
    madeCurrentDateTime: 'madeCurrentDateTime',
    arrivedDateTime: 'arrivedDateTime',
    finishedDateTime: 'finishedDateTime',
    hcpAbortedDateTime: 'hcpAbortedDateTime',
    abortedBy: 'abortedBy',
    jobStatus: 'jobStatus',
    jobStatusBeforeAbort: 'jobStatusBeforeAbort',
    controllerAbortedReason: 'controllerAbortedReason',
    controllerAbortedNotes: 'controllerAbortedNotes',
    controllerReverseReason: 'controllerReverseReason',
    controllerReverseNotes: 'controllerReverseNotes',
    hcpAbortedReason: 'hcpAbortedReason',
    hcpAbortedNotes: 'hcpAbortedNotes',
    hcpReverseReason: 'hcpReverseReason',
    hcpReverseNotes: 'hcpReverseNotes',
    postVisitNotes: 'postVisitNotes',
    withdrawnReason: 'withdrawnReason',
    withdrawnNotes: 'withdrawnNotes',
};

const hcp2Attributes: HcpAttributeNames = {
    hcpId: 'buddyId',
    hcpName: 'buddyName',
    hcpGrade: 'buddyGrade',
    madeCurrentDateTime: 'buddyMadeCurrentDateTime',
    arrivedDateTime: 'buddyArrivedDateTime',
    finishedDateTime: 'buddyFinishedDateTime',
    hcpAbortedDateTime: 'buddyHcpAbortedDateTime',
    abortedBy: 'buddyAbortedBy',
    jobStatus: 'buddyJobStatus',
    jobStatusBeforeAbort: 'buddyJobStatusBeforeAbort',
    controllerAbortedReason: 'buddyControllerAbortedReason',
    controllerAbortedNotes: 'buddyControllerAbortedNotes',
    controllerReverseReason: 'buddyControllerReverseReason',
    controllerReverseNotes: 'buddyControllerReverseNotes',
    hcpAbortedReason: 'buddyHcpAbortedReason',
    hcpAbortedNotes: 'buddyHcpAbortedNotes',
    hcpReverseReason: 'buddyHcpReverseReason',
    hcpReverseNotes: 'buddyHcpReverseNotes',
    postVisitNotes: 'postVisitNotesBuddy',
    withdrawnReason: 'withdrawnReason',
    withdrawnNotes: 'withdrawnNotes',
};

export const getHcpAttributeNames = (isBuddy: boolean): HcpAttributeNames => {
    return isBuddy ? hcp2Attributes : hcp1Attributes;
};
